import styled from 'styled-components';

import { GRAY, PRIMARY } from 'constants/colors';

import { rSize } from 'components/utils';
import { brightness } from 'utils/misc';

import { FIRST_CELL_WIDTH } from '../const';

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${rSize(30)};
  box-sizing: border-box;

  .roster-grid {
    table-layout: fixed;

    th,
    td {
      border: 0;
      padding: 0;
      vertical-align: top;
      position: relative;
      text-align: center;
      box-sizing: border-box;
    }

    thead tr:first-child th:first-child,
    td:first-child {
      width: ${FIRST_CELL_WIDTH};
      text-align: left;
    }

    thead {
      th {
        padding: 8px;
        vertical-align: middle;

        &:not(:first-child) {
          text-align: center;
        }
      }
    }

    tbody {
      tr {
        &:first-child td {
          padding-top: 0;
        }

        &:last-child td {
          padding-bottom: 0;
        }

        & + tr {
          border-top: 1px dashed ${GRAY};
        }
      }
      tr:not(.no-highlight) {
        td {
          transition: background-color 0.15s ease-in-out 0.1s;
        }

        .day-columns {
          .is-today,
          .is-weekend {
            transition: background-color 0.15s ease-in-out 0.1s;
          }
        }

        &:hover {
          td {
            background-color: ${brightness(PRIMARY, 90)};
          }

          .day-columns {
            .is-today,
            .is-weekend {
              background-color: ${brightness(PRIMARY, 90)};
            }
          }
        }
      }
    }

    .custom-duties-row {
      border-top: 0;

      & + .custom-duties-row {
        border-top: 1px dashed ${GRAY};
      }

      td::before {
        display: none !important;
      }
    }

    td:not(.day-cell) + .day-cell {
      border-left: 1px dashed ${GRAY};
    }

    tr:not(:first-child) td:not(:last-child),
    .day-columns:not(:first-child) .day:not(:last-child) {
      &::before {
        content: '';
        position: absolute;
        z-index: 2;
        width: 8px;
        height: 8px;
        right: 0;
        top: 0;
        transform: translate(50%, -50%);
        background-color: white;
      }
    }

    .border-right:not(:last-child) {
      border-right: 1px dashed ${GRAY};
    }

    .plan-unit-name {
      padding-left: 20px;
    }

    &.border-top {
      border-top: 1px dashed ${GRAY};
    }

    .is-weekend {
      background-color: ${brightness(GRAY, 85)};
    }

    .is-today {
      background-color: ${brightness(PRIMARY, 90)};
    }

    .is-yesterday,
    .is-today,
    .is-friday,
    .is-weekend {
      &::before {
        display: none;
      }
    }
  }

  .MuiAccordionSummary-root {
    width: ${FIRST_CELL_WIDTH};
    padding-right: calc(100% - ${FIRST_CELL_WIDTH});
    padding-left: 0 !important;
    justify-content: center !important;
  }

  .roster-body {
    position: relative;
    flex-grow: 1;

    .wrap-container {
      display: block;
      padding-right: 16px;
    }
  }
`;
